import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["menu", "searchInput", "option"]
  static values = { open: Boolean, search: Boolean }

  connect() {
    useClickOutside(this, { element: this.menuTarget })
  }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
      this.filterOptions()
    }
  }

  clickOutside(event) {
    if (this.openValue) {
      event.preventDefault()
      this.close()
    }
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove('hidden')
      if (this.searchValue && this.hasSearchInputTarget) {
        setTimeout(() => this.searchInputTarget.focus(), 10)
      }
    } else {
      this.menuTarget.classList.add('hidden')
    }
  }

  filterOptions() {
    if (!this.hasSearchInputTarget) return

    const query = this.searchInputTarget.value.toLowerCase()

    this.optionTargets.forEach(option => {
      const label = option.dataset.label || ''
      if (label.includes(query)) {
        option.classList.remove('hidden')
      } else {
        option.classList.add('hidden')
      }
    })
  }
}
